import React, { useState, useEffect } from 'react'

interface Props {
  fileUrl?: string | null
  onChange: (file: File | null) => void
  showDownload?: boolean
}

const ConsentFormUploader: React.FC<Props> = ({ fileUrl, onChange, showDownload = true }) => {
  const [localFile, setLocalFile] = useState<File | null>(null)
  const [previewUrl, setPreviewUrl] = useState<string | null>(fileUrl || null)

  useEffect(() => {
    setPreviewUrl(fileUrl || null)
  }, [fileUrl])

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null
    if (file) {
      if (file.type !== 'application/pdf') {
        alert('Only PDF files are allowed')
        return
      }
      setLocalFile(file)
      const tempUrl = URL.createObjectURL(file)
      setPreviewUrl(tempUrl)
      onChange(file)
    } else {
      setLocalFile(null)
      setPreviewUrl(null)
      onChange(null)
    }
  }


  return (
    <div className="mb-3">
      <label className="form-label fw-semibold">Consent Form</label>
      <input
        type="file"
        accept=".pdf"
        onChange={handleFileChange}
        className="form-control"
      />

      {showDownload && previewUrl && (
        <div className="mt-2 d-flex align-items-center justify-content-between border p-2 rounded">
          <span className="text-muted small">{localFile?.name || 'Uploaded file'}</span>
          <a
            href={previewUrl}
            download={localFile?.name || 'consent-form'}
            className="btn btn-sm btn-outline-primary"
          >
            Download
          </a>
        </div>
      )}
    </div>
  )
}

export default ConsentFormUploader
